import { AuthService } from './../../../shared/services/auth.service';
import { ILogin, IAuthUser } from '../../../_models/Account/user';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  loading: boolean;
  login: ILogin;
  loginForm: FormGroup;
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.createLoginForm();
  }

  submit() {
    if (this.loginForm.valid) {
      this.loading = true;
      this.login = Object.assign({}, this.loginForm.value);
      this.authService.login(this.login).subscribe((response: IAuthUser) => {
        if (response) {

          localStorage.setItem('token', response.tokenString);

          let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
          let query = returnUrl ? this.QueryStringToJSON(returnUrl) : {};
          let url = returnUrl && returnUrl.split('?').length >= 2 ? returnUrl.split('?')[0] : returnUrl;
          this.router.navigate([url || '/'], { queryParams: query });
        }
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false
      );
    }
  }

  QueryStringToJSON(query) {
    query = query.split('?').length >= 2 ? query.split('?')[1] : "";
    if (query) {
      let pairs = query.split('&');

      var result = {};
      pairs.forEach((pair) => {
        let pair_t = pair.split('=');
        result[pair_t[0]] = decodeURIComponent(pair_t[1] || '');
      });

      return JSON.parse(JSON.stringify(result));
    }
    else {
      return {};
    }
  }

  createLoginForm() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }
}
